import { CompRef, DocumentServicesObject } from '@wix/document-services-types';
import { TPA_COMPONENT_TYPES } from '../types';

export function getBuilderAppData(
  compRef: CompRef,
  documentServicesAPI: DocumentServicesObject,
): {
  isBuilder: boolean;
  builderCompData: ReturnType<
    DocumentServicesObject['builder']['components']['getCompAppData']
  >;
} {
  const type = documentServicesAPI.components.getType(compRef);
  const builderCompData =
    documentServicesAPI.builder.components.getCompAppData(type);

  // TODO: DM returns data for OOI apps under builder namespace, we need to additionally check for refType
  const isBuilder =
    !!builderCompData &&
    // @ts-expect-error - refType exists at runtime but not in AppData interface
    !TPA_COMPONENT_TYPES.includes(builderCompData.refType);
  return { isBuilder, builderCompData };
}
